import { qreq } from "../../shared/qrequest";
import Alert from "../Alert";
import BaseCom from "../BaseCom";
import Card from "../Card";
import FormInput from "../FormInput";
import Icon from "../Icon";
import LoadingAlert from "../LoadingAlert";
import { Pop } from "../PopModal";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class Survey extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            info: {}
        };
        this.onChange = this.onChange.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.onSelectAnswer = this.onSelectAnswer.bind(this);
        this.getVariable = this.getVariable.bind(this);
        this.processVariables = this.processVariables.bind(this);
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        if(this.props.params.ident) {
            qreq.get('/api/survey/public?ident=' + this.props.params.ident, j => {
                if (j.item)
                    this.setState({ survey: j.item, loaded: true });
                else
                    this.alert(j.errorMessage);
            }, this.unkownErrorCallback);
        }
        else {
            qreq.get('/api/survey/public?masterID=' + this.props.params.masterID, j => {
                if (j.item)
                    this.setState({ survey: j.item, loaded: true });
                else
                    this.alert(j.errorMessage);
            }, this.unkownErrorCallback);
        }
    }

    onChange(v) {
        this.setState({ info: { ...this.state.info } });
    }

    onSelectChange(i, e) {
        var info = { ...this.state.info };
        info[i.id] = e.target.value;
        this.setState({ info: info });
    }

    onSelectAnswer(i, j) {
        var info = { ...this.state.info };
        info[i.id] = j.id;
        this.setState({ info: info });
    }

    getVariable(name) {
        var val = null;
        this.state.survey.pages.forEach(i => {
            i.items.forEach(j => {
                if (!val && j.varName === name) {
                    val = this.state.info[j.id];
                }
            });
        });
        if(!val)
            val = '';
        return val;
    }

    getScore() {
        var score = 0;
        this.state.survey.pages.forEach(i => {
            i.items.forEach(j => {
                if((j.itemType === 'radio' || j.itemType === 'select') && this.state.info[j.id]) {
                    j.answers.forEach(k => {
                        console.log('test', k.id, this.state.info[j.id]);
                        if(Number(k.id) === Number(this.state.info[j.id]))
                            score += k.score;
                    });
                }
            });
        });
        return score;
    }

    processVariables(text) {
        const reg = /@([a-z0-9]+)/g;
        var match;
        while ((match = reg.exec(text)) !== null) {
            if(match && match[0] && match[1]) {
                if(match[1] === 'score')
                    text = text.replace(match[0], this.getScore());
                else
                    text = text.replace(match[0],this.getVariable(match[1]));
            }
        }
        return text;
    }

    nl2br(text) {
        return text.replace(/\n/g, "<br />\n");
    }

    submit(e) {
        if (e) e.preventDefault();
        var final = this.state.page === this.state.survey.pages.length;
        var page = this.state.survey.pages[this.state.page - 1];

        var info = { ...this.state.info };


        var ok = true;
        page.items.forEach(i => {
            if (i.itemType !== 'label' && !i.isOptional && !info[i.id])
                ok = false;
        });

        if (!ok) {
            Pop.show('There are answers that are still blank.', 'Validation');
            return;
        }

        if (!final)
            this.setState({ page: this.state.page + 1 });
        else {
            this.setState({ submitting: true });
            qreq.post('/api/survey/public/submit?revisionID=' + this.state.survey.id, info, j => {
                if (j.errorCode === 0)
                    this.setState({ success: true });
                else
                    this.alert(j.errorMessage);
                this.setState({ submitting: false });
            }, () => {
                this.unkownErrorCallback();
                this.setState({ submitting: false });
            });
        }
    }

    render() {
        if (!this.state.loaded) {
            return <div className="container py-3"><LoadingAlert /></div>;
        }
        if (!this.state.survey.pages || this.state.survey.pages.length === 0) {
            return <div className="container py-3"><Alert type="danger">Survey has no pages.</Alert></div>
        }

        var page = this.state.survey.pages[this.state.page - 1];

        return <section className="survey">
            <div className="container py-3">
                <h1 className="text-center my-2">{this.state.survey.name}</h1>
                {this.state.survey.pages.length > 1 ? <h4 className="text-center my-2 mb-4 text-secondary">Step {this.state.page} of {this.state.survey.pages.length}</h4> : ''}
                {this.state.page < 0 || this.state.page > this.state.survey.pages.length ? <Alert type="danger">Invalid page.</Alert> :
                    this.state.success ? <Card title="Submission Complete">
                        <p className="lead">You have successfully submitted this survey.</p>
                        <div className="mt-3 text-center">
                            <a href="https://www.mobilewoundcaremd.com" role="button" className="btn btn-primary btn-lg">Back to Homepage</a>
                        </div>
                    </Card> :
                        <form onSubmit={this.submit}>
                            <Card>
                                {page.items.map(i => <div key={i.id} className="my-3">
                                    <label className="form-label fs-5">{this.processVariables(i.content)}</label>
                                    {i.descriptor ? <div className="my-2 text-secondary" dangerouslySetInnerHTML={{ __html: this.processHTML(this.nl2br(this.processVariables(i.descriptor))) }}></div> : ''}
                                    {i.itemType === 'radio' ? <div className="mb-3">
                                        {i.answers.map(j => <div key={j.id}>
                                            <div className="form-group mb-2"><div className="form-check form-switch">
                                                <input className="form-check-input" type="checkbox" id={'a-' + j.id} checked={this.state.info[i.id] === j.id} onChange={() => this.onSelectAnswer(i, j)} />
                                                <label className="form-check-label" htmlFor={'a-' + j.id}>{j.content}</label>
                                            </div></div>
                                        </div>)}
                                    </div> :
                                        i.itemType === 'select' ? <div className="mb-3">
                                            <select className="form-control form-control-lg" required onChange={e => this.onSelectChange(i, e)}>
                                                <option value="">Select One</option>
                                                {i.answers.map(j => <option key={j.id} value={j.id}>{j.content}</option>)}
                                            </select>
                                        </div> : i.itemType === 'text' ||
                                        i.itemType === 'textarea' ||
                                        i.itemType === 'email' ||
                                        i.itemType === 'number' ? 
                                        <FormInput model={this.state.info} name={i.id} type={i.itemType} label={i.itemType === 'email' ? 'Email address...' : i.itemType === 'number' ? 'Fill in a number...' : 'Fill in your answer...'} labelAsPlaceholder onChange={this.onChange} placeholder="Fill in your answer..." required={!i.isOptional} inputClassName="form-control-lg" />
                                            : ''}
                                </div>)}
                                <div className="d-flex justify-content-between">
                                    {this.state.page !== 1 ? <div className="text-start">
                                        <button type="button" className="btn btn-secondary btn-lg" onClick={() => this.setState({ page: this.state.page - 1 })}><Icon icon="faCaretLeft" /> Back</button>
                                    </div> : ''}
                                    <div className="flex-fill text-end">
                                        {this.state.page === this.state.survey.pages.length ? <button type="submit" className="btn btn-success btn-lg" disabled={this.state.submitting}>Submit <Icon icon="faSave" /></button> : <button type="submit" className="btn btn-primary btn-lg">Next <Icon icon="faCaretRight" /></button>}
                                    </div>
                                </div>
                            </Card>
                        </form>}
            </div>
        </section>;
    }
}

export default withParamsAndNavigate(Survey);